import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";
import "./CustomDropdown.css";

export default function CustomDropdown({
  options = [],              
  value,                      
  onChange,                   
  placeholder = "Select...",  
  disabled = false,           
  width = "auto",            
  minWidth = "8.75rem",         
  zIndex = 2000,
  autoWidth = false,
  showIcon = true,         
}) {
  const [open, setOpen] = useState(false);
  const [openUpwards, setOpenUpwards] = useState(false); 
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const handleToggle = () => {
    if (disabled) return;

    if (!open && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;
      setOpenUpwards(spaceBelow < 200 && spaceAbove > spaceBelow);
    }

    setOpen((v) => !v);
  };
  const selected = options.find((opt) => opt.value === value);

  return (
    <div
      className={`custom-dropdown-wrapper ${disabled ? "disabled" : ""}`}
      ref={dropdownRef}
      style={{
        width: autoWidth ? "fit-content" : width,
        minWidth,
        position: "relative",
      }}
    >
      <button
        type="button"
        className={`dropdown-trigger ${open ? "open" : ""}`}
          onClick={handleToggle}
        disabled={disabled}
      >
        <span className="dropdown-value">
          {selected ? selected.label : placeholder}
        </span>
        {showIcon && (
          <ChevronDown
            size={18}
            className={`dropdown-icon ${open ? "rot" : ""}`}
          />
        )}
      </button>

     {open && (
  <ul
    className={`dropdown-list ${openUpwards ? "open-up" : "open-down"}`}
    style={{
      zIndex,
    }}
  >
          {options.map((opt) => (
            <li
              key={opt.value}
              className={`dropdown-item ${opt.value === value ? "selected" : ""}`}
              onClick={() => {
                onChange(opt.value);
                setOpen(false);
              }}
            >
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
